{
  "nl": {
    "form": {
      "actions": {
        "cancel": "Annuleren",
        "clear": "Wissen",
        "closeFullPage": "Volledige pagina sluiten",
        "copyText": "Klik om tekst te kopiëren",
        "create_and_attach_phase": "Aanmaken en koppelen aan fase",
        "create_and_send": "Aanmaken en versturen",
        "create_and_send_to_customer": "Aanmaken en verzenden naar klant",
        "create_and_share": "Maak aan en deel met klant",
        "create_and_share_partners_only": "Maak aan en deel met partner(s)",
        "create_and_share_with_partners": "Maak aan en deel met klant en partner(s)",
        "next": "Volgende",
        "only_create": "Alleen aanmaken",
        "openFullPage": "Open in volledige pagina",
        "save": "Opslaan",
        "saveChanges": "Sla veranderingen op",
        "save_as_draft": "Opslaan als concept",
        "search": "Zoeken...",
        "send": "Verzenden",
        "send_and_create_another": "Verzenden en nog één maken",
        "send_to_customer": "Verzenden naar klant",
        "share_with_customer": "Delen met klant",
        "submit": "Opslaan",
        "submit_and_create_another": "Opslaan en nog één maken"
      },
      "back": "Vorige stap",
      "labels": {
        "columns": "Kolommen",
        "from": "Van",
        "no_results": "Geen resultaten",
        "optional": "(optioneel)",
        "to": "Tot"
      },
      "notifications": {
        "textHasBeenCopied": "   Tekst is gekopieerd"
      },
      "password": "Wachtwoord",
      "send_moment": {
        "attach_failed": "Aangemaakt, maar niet gekoppeld aan de fase. Koppel het opnieuw in de workflow.",
        "concept_description": "Niemand krijgt iets te zien. Je verstuurt later zelf, of koppelt alsnog aan een fase.",
        "concept_title": "Opslaan als concept",
        "item_decision": "deze beslissing",
        "item_survey": "deze enquête",
        "item_todo": "deze taak",
        "now_description_decision": "De klanten van de geselecteerde units krijgen de beslissing meteen, met een melding.",
        "now_description_survey": "De klanten van de geselecteerde units krijgen de enquête meteen, met een melding.",
        "now_description_todo": "De toegewezenen van de geselecteerde units krijgen de taak meteen, met een melding.",
        "now_title": "Nu versturen",
        "phase_description": "Gaat per unit vanzelf uit zodra die unit de fase bereikt.",
        "phase_label": "Fase",
        "phase_title": "Koppelen aan een fase",
        "summary_concept": "Nog niets verstuurd",
        "summary_phase": "Gaat uit zodra een unit de fase bereikt",
        "title": "Wanneer krijgt de klant {item} te zien?",
        "workflow_help": "Wat is een workflow?",
        "workflow_help_more": "Meer lezen",
        "workflow_help_text": "Een workflow zijn de fases die elke unit doorloopt. Koppel je iets aan een fase, dan krijgt de klant het vanzelf te zien zodra zijn unit die fase bereikt."
      },
      "shortcuts": {
        "save_mac": "⌘ + Enter om op te slaan",
        "save_windows": "Ctrl + Enter om op te slaan",
        "send_mac": "⌘ + Enter om te verzenden",
        "send_windows": "Ctrl + Enter om te verzenden"
      },
      "steps": "Stap {count} van {total}",
      "writeEmployeeNameReject": "Schrijf <i><b>{employeeName}</b></i> neer om het verwijderen te bevestigen."
    }
  }
}
